module.exports = __webpack_public_path__ + "img/pic_12.eec3d960.jpg";